import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../../../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class OnlyLoggedUsersGuard  {
    private authService = inject(AuthService);
    private router = inject(Router);
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.authService.isLoggedIn()) {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['login']);

            return false;
        }

        return true;
    }
}
